export enum KeyboardEventCodes {
  SPACE = 'Space',
  ENTER = 'Enter',
}
